export class FlowIncorrectlyError extends Error {
    constructor() {
        super();
        // Error when trying to change status of buyout or similar case
        this.message =
            'There are no available statuses to switch to. The scheme is not correct. Contact your logistician.';
    }
}
